<ul class="social-icon-list list-unstyled mb-0">
   <li class="list-inline-item" *ngFor="let socialIcon of socialIcons"><a href="{{socialIcon.links}}"><i class="{{socialIcon.icons}}"></i></a></li>
</ul>
<!-- social-icon-list wrap close -->
